    const TestimonialData = [
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/VZsVpA6YgTthmNQe6",
            stars: 5,
            name: "Chirag Jain",
            reviewUrl:
                "https://maps.app.goo.gl/VZsVpA6YgTthmNQe6",
            text: "I came here for my root canal treatment for my front teeth. The clinic is exactly how it looks in photos, very clean and spacious. The doctor explained the treatment in simple words. The treatment was painless, and i would recommend this clinic if you want to get quality treatment done.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/N1MCundrCDnQwwaq6",
            stars: 5,
            name: "Kartik Banjara",
            reviewUrl:
                "https://maps.app.goo.gl/N1MCundrCDnQwwaq6",
            text: "Had a very good experience at Denvia dental clinic. The doctor is very knowledgeable and made us comfortable during the whole procedure. Definitely getting my future dental treatments here.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/87ZPDhLwwfNcB92v7",
            stars: 5,
            name: "Aman Jain",
            reviewUrl:
                "https://maps.app.goo.gl/87ZPDhLwwfNcB92v7",
            text: "I had a great experience at denvia dental clinic for teeth whitening. Dr. Aditya was very professional, explained the entire procedure clearly, and made me feel completely comfortable throughout the treatment. The results were excellent, and the pricing was very reasonable compared to other clinics. The clinic is clean, well-maintained, and the staff is polite and helpful. Highly recommend Dr. Aditya and his team for quality dental care at good prices.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/vuF58txSzzuGKSG79",
            stars: 5,
            name: "Shubham Bakliwal",
            reviewUrl:
                "https://maps.app.goo.gl/vuF58txSzzuGKSG79",
            text: "Had a great experience at Denvia Dental Clinic. The clinic is clean and well-maintained, and Dr. Aditya is very professional and gentle. Everything was explained clearly, and I also appreciated that they didn’t rush and took time to answer all my questions.  The treatment was completely painless. Highly recommend Denvia Dental Clinic to anyone looking for honest advice, quality dental care, and a comfortable experience.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/U3vyvc6QNxyvj5Di6",
            stars: 5,
            name: "Aditi Jain",
            reviewUrl:
                "https://maps.app.goo.gl/EdpevdEKWpWpkbNB9",
            text: "I had a really good experience at Denvia Dental Clinic. The doctor is gentle, explains everything clearly and makes you feel very comfortable. The staff is polite and helpful, and the clinic is clean and hygienic. I’m very happy with the treatment.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/DtK8nGaXHygKdgM68",
            stars: 5,
            name: "Simran Sakhre",
            reviewUrl:
                "https://maps.app.goo.gl/DtK8nGaXHygKdgM68",
            text: "I recently visited denvia multispeciality dental clinic for my mother’s tooth extraction. The treatment as a whole was a fantastic experience right from the consultation part till the end of the treatment Dr Aditya was extremely polite and welcoming. The ambience of the clinic gives a calming environment for the patients. The staff was extremely cooperative and at every step of the treatment Dr Aditya made sure that my mom felt comfortable. The treatment was explained in simple words which made it easier for us to understand the whole process. The clinic is equipped with high end amenities with extremely affordable prices. Highly recommended for the expertise of the doctor and the soothing clinic atmosphere.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/3uLdCA1GXy75htoM8",
            stars: 5,
            name: "Vinay Maheshwari",
            reviewUrl:
                "https://maps.app.goo.gl/3uLdCA1GXy75htoM8",
            text: "I got my teeth cleaning and filling done here. The doctor explained the process properly and the treatment was done smoothly. I am very happy with my treatment.",
        },
        
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/UbSQ7steWPBpJ7DT8",
            stars: 5,
            name: "Rishi Dadhich",
            reviewUrl:
                "https://maps.app.goo.gl/UbSQ7steWPBpJ7DT8",
            text: "I visited the clinic for my mother’s gum treatment, Dr. Aditya explained the situation properly, gave us options for treatment, he was very calm during the treatment and made sure my mother is comfortable during the whole treatment. The treatment was painless and was done quickly. Definitely best dental clinic in shyam nagar.",
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/t3fHXjcGR1wQe7Bo8",
            stars: 5,
            name: "Anushka Baid",
            reviewUrl:
                "https://maps.app.goo.gl/t3fHXjcGR1wQe7Bo8",
            text: "Great Clinic! I honestly have been scared of going to dentists, but Dr. Aditya Jain was very helpful and the cleaning had wonderful results. We also noticed a few other issues early stages and Will be able to fix them too"
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/i3PiApJ1TJCDZtG97",
            stars: 5,
            name: "Renu Jain",
            reviewUrl:
                "https://maps.app.goo.gl/i3PiApJ1TJCDZtG97",
            text: "Had my dental implant done by Dr. Aditya and the experience was very good. The procedure was smooth, painless, and well explained, and the prices are also reasonable. Highly recommended."
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/9JxUbJ7zspPzrzTg8",
            stars: 5,
            name: "Ishan Jain",
            reviewUrl:
                "https://maps.app.goo.gl/9JxUbJ7zspPzrzTg8",
            text: "Very professional and friendly. The doctor walked us through the whole procedure and helped us understand different options. Very affordable for the services provided. Highly recommended!!"
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/DwNGrbdyFjgLNy68A",
            stars: 5,
            name: "Mahak Saini",
            reviewUrl:
                "https://maps.app.goo.gl/DwNGrbdyFjgLNy68A",
            text: "I visit 1st time and totally i setisfy... Thanku so much denvia dental clinic"
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/vqmTtPRWqWtcFdQW6",
            stars: 5,
            name: "Sneha Chawla",
            reviewUrl:
                "https://maps.app.goo.gl/vqmTtPRWqWtcFdQW6",
            text: "I had a great experience and I would recommend you to guys if you are from jaipur so you can totally trust him"
        },
        {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/teXrto82MDYiBUHe7",
            stars: 5,
            name: "Rahul Surana",
            reviewUrl:
                "https://maps.app.goo.gl/teXrto82MDYiBUHe7",
            text: "Great experience and very good and efficient doctor with nice place and proper hygiene"
        },
         {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/TVavPcdbLd4b6uNj9",
            stars: 5,
            name: "Kanika Lakhiwal",
            reviewUrl:
                "https://maps.app.goo.gl/TVavPcdbLd4b6uNj9",
            text: "Very good doctor & all the facilities was awesome"
        },
         {
            title: "Denvia Dental Clinic",
            url: "https://maps.app.goo.gl/oLUXBf1FvdQy4ivh7",
            stars: 5,
            name: "Heena Bhati",
            reviewUrl:
                "https://maps.app.goo.gl/oLUXBf1FvdQy4ivh7",
            text: "Very kind and knowledge doctor and tells accurately about your problems "
        },
    ];

    export default TestimonialData;